import { render } from "./faqSection.vue?vue&type=template&id=6bd1bb4a&scoped=true"
import script from "./faqSection.vue?vue&type=script&lang=js"
export * from "./faqSection.vue?vue&type=script&lang=js"

import "./faqSection.vue?vue&type=style&index=0&id=6bd1bb4a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd1bb4a"]])

export default __exports__